<script>

    import { toast } from 'bulma-toast'
    import { tilPricingsStore, modalStore, adminStore } from '../stores'

    import TilService from '../$services/til.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Input from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import SelectOwners from '../$components/select.owners.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Table from '../$components/table.svelte'
    import Pagination from '../$components/pagination.svelte'
    import Event from '../$components/event.svelte'
    import { ZONE_OPTIONS } from './zones'

    const serviceOptions = [
        { value: 'Express', text: 'Express' },
        { value: 'Metro Express', text: 'Metro Express' },
    ]

    let query = {
        page: 0,
        ownerId: '60edc374e9091e00151699c0',
        service: "",
        pickupZoneOperative: "",
        deliveryZoneOperative: "",
        pickupIATA: "",
        deliveryIATA: "",
    }

    let loading = false
    let metadata = {}

    getTilPricings()

    async function getTilPricings(reset = false) {

        if(reset === true)
            query.page = 0

        loading = true
        const resp = await TilService.getTilPricings(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tilPricingsStore.set(resp.data.pricings)
        metadata = resp.data.metadata
    }

</script>

<Event eventId="til_pricing_updated" on:dispatch={() => getTilPricings(true)} />

<Table items={ $tilPricingsStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column is-narrow">
                <SelectOwners
                    bind:ownerId={ query.ownerId }
                    on:change={() => getTilPricings(true)}
                />
            </div>
            <div class="column">
                <Select
                    bind:value={ query.service }
                    text="Servicio"
                    options={ serviceOptions }
                    required={ false }
                    on:change={() => getTilPricings(true)}
                />
            </div>
            <div class="column">
                <Select
                    bind:value={ query.pickupZoneOperative }
                    text="Zona origen"
                    options={ ZONE_OPTIONS }
                    required={ false }
                    on:change={() => getTilPricings(true)}
                />
            </div>
            <div class="column">
                <Select
                    bind:value={ query.deliveryZoneOperative }
                    text="Zona destino"
                    options={ ZONE_OPTIONS }
                    required={ false }
                    on:change={() => getTilPricings(true)}
                />
            </div>

            {#if $adminStore.role === 'admin'}
                <div class="column is-narrow">
                    <div>
                        <ButtonModal modalId="tilPricing_download_modal" icon="download" text="Descargar" />
                        <ButtonModal modalId="tilPricing_upload_modal" icon="file-upload" text="Subir" />
                        <ButtonModal modalId="tilPricing_create_modal" icon="plus" text="Crear" />
                    </div>
                </div>
            {/if}
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getTilPricings } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Servicio</th>
            <th>Peso</th>
            <th>Zona origen</th>
            <th>Zona destino</th>
            <th>IATA origen</th>
            <th>IATA destino</th>
            <th class="has-text-right">Precio</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $tilPricingsStore as pricing, index}
            <tr>
                <td>{ (metadata.items * query.page) + (index + 1) }</td>
                <td>{ pricing.service }</td>
                <td>{ pricing.volumetricMin }kg a { pricing.volumetricMax }kg</td>
                <td>{ pricing.pickupZoneOperative || '—' }</td>
                <td>{ pricing.deliveryZoneOperative || '—' }</td>
                <td>{ pricing.pickupIATA || '—' }</td>
                <td>{ pricing.deliveryIATA || '—' }</td>
                <td class="has-text-right">{ NumeralMethods.cash(pricing.price) }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('tilPricing', 'modal', pricing)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
